<div
  class="display-flex align-items-center justify-content-center action-button"
  (click)="close()"
  [ngClass]="{ 'close-mobile': data.isMobile }">
  <mat-icon>close_small</mat-icon>
</div>

<div class="slide" [ngClass]="{ isMobile: data.isMobile }">
  <div class="files-counter" *ngIf="data.showMetaInfo && data.imageUrls?.length">
    {{ currentIndex + 1 }} of {{ data.imageUrls.length }}
  </div>

  <ng-container *appIsVideo="currentUrl; else imageOrFileTemplate">
    <video
      class="image-size"
      controls
      preload="metadata"
      [class.landscape]="currentUrl.imageOrientation === ImageOrientation.LandscapeRight"
      [src]="currentUrl['cloudUri']"
      [poster]="currentUrl?.thumbnailFileUploadCloudUri || ''"
      (click)="$event.stopPropagation()"></video>
    <div class="action-buttons">
      <div
        *ngIf="data.isEditorMode && !data.showMetaInfo"
        class="display-flex align-items-center justify-content-center"
        (click)="deleteImage(currentUrl.cloudUri)">
        <mat-icon>delete</mat-icon>
      </div>
    </div>
  </ng-container>

  <ng-template #imageOrFileTemplate>
    <ng-container
      *ngIf="isImage(currentUrl['thumbnailFileUploadCloudUri'] || currentUrl['cloudUri']); else fileTemplate">
      <div class="display-flex justify-content-center" [ngClass]="{ 'image-wrapper': data.isMobile }">
        <div
          class="images-list-arrow"
          *ngIf="data.isMobile && this.data.imageUrls?.length > 1"
          (click)="goToPrevious()">
          <mat-icon>chevron_left</mat-icon>
        </div>

        <img
          class="current-image image-size"
          [src]="currentUrl['thumbnailFileUploadCloudUri'] || currentUrl['cloudUri']"
          [class.landscape]="currentUrl.imageOrientation === ImageOrientation.LandscapeRight"
          (click)="$event.stopPropagation()" />

        <div class="images-list-arrow" *ngIf="data.isMobile && this.data.imageUrls?.length > 1" (click)="goToNext()">
          <mat-icon>chevron_right</mat-icon>
        </div>
      </div>

      <div class="action-buttons">
        <div
          class="display-flex align-items-center justify-content-center action-button"
          (click)="openInNewTab(currentUrl.cloudUri)">
          <mat-icon>open_in_new</mat-icon>
        </div>

        <div
          *ngIf="data.isEditorMode && !data.showMetaInfo"
          class="display-flex align-items-center justify-content-center action-button"
          (click)="deleteImage(currentUrl.cloudUri)">
          <mat-icon>delete</mat-icon>
        </div>
      </div>
    </ng-container>

    <ng-template #fileTemplate>
      <div class="file-preview display-flex flex-column align-items-center justify-content-center grid-gap-24">
        <div
          class="file-preview-pagging-top display-flex flex-column align-items-center justify-content-center grid-gap-8">
          <span class="file-preview-description">Preview is not available</span>

          <span *ngIf="currentUrl?.originalFileName || currentUrl.internalName" class="file-preview-title">
            {{ currentUrl.originalFileName ?? currentUrl.internalName }}
          </span>
        </div>

        <div class="display-flex grid-gap-10">
          <div
            *ngIf="!data.showMetaInfo"
            class="display-flex align-items-center justify-content-center action-button"
            (click)="downloadFile(currentUrl.cloudUri)">
            <mat-icon>download</mat-icon>
          </div>

          <div
            class="display-flex align-items-center justify-content-center action-button"
            (click)="openInNewTab(currentUrl.cloudUri)">
            <mat-icon>open_in_new</mat-icon>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <div
          *ngIf="!data.showMetaInfo"
          class="display-flex align-items-center justify-content-center action-button"
          (click)="downloadFile(currentUrl.cloudUri)">
          <mat-icon>download</mat-icon>
        </div>

        <div
          class="display-flex align-items-center justify-content-center action-button"
          (click)="openInNewTab(currentUrl.cloudUri)">
          <mat-icon>open_in_new</mat-icon>
        </div>

        <div
          *ngIf="data.isEditorMode && !data.showMetaInfo"
          class="display-flex align-items-center justify-content-center action-button"
          (click)="deleteImage(currentUrl.cloudUri)">
          <mat-icon>delete</mat-icon>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>

<div class="file-title" *ngIf="data.showMetaInfo && currentUrl.originalFileName">
  <app-avatar-simple
    *ngIf="currentUrl.assigneeId"
    [userName]="currentUrl.assigneeId | usernameById: (users$ | async)"
    [userId]="currentUrl.assigneeId"
    [showName]="false"
    [containerCss]="'s-32'"></app-avatar-simple>
  <span class="filename">
    {{ currentUrl.originalFileName }}
  </span>

  <span class="created" *ngIf="currentUrl.created">
    {{ currentUrl.created | conditionalDatePipe }}
  </span>

  <div class="file-actions display-flex grid-gap-2">
    <div
      class="file-action display-flex align-items-center justify-content-center"
      (click)="downloadFile(currentUrl.cloudUri)">
      <mat-icon class="material-icons-outlined">file_download</mat-icon>
    </div>

    <div
      *ngIf="data.isEditorMode"
      class="file-action display-flex align-items-center justify-content-center"
      (click)="deleteImage(currentUrl.cloudUri)">
      <mat-icon>delete</mat-icon>
    </div>
  </div>
</div>

<div class="images-list display-flex" *ngIf="!data.isMobile">
  <div class="images-list-arrow" (click)="goToPrevious()">
    <mat-icon>chevron_left</mat-icon>
  </div>
  <div class="thumbs display-flex" (click)="$event.stopPropagation()">
    <ng-container *ngFor="let mediaUrl of data.imageUrls">
      <ng-container *appIsVideo="mediaUrl; else imageOrFileTemplateThumb">
        <video
          id="thumb-{{ mediaUrl.cloudUri }}"
          class="thumb-video"
          preload="metadata"
          [class.landscape]="mediaUrl.imageOrientation === ImageOrientation.LandscapeRight"
          [src]="mediaUrl['cloudUri']"
          [poster]="mediaUrl?.thumbnailFileUploadCloudUri || ''"
          (click)="onChange(mediaUrl['cloudUri'])"
          [class.current]="mediaUrl['cloudUri'] === currentUrl['cloudUri']"></video>
      </ng-container>

      <ng-template #imageOrFileTemplateThumb>
        <ng-container *ngIf="isImage(mediaUrl['cloudUri']); else fileTemplateThumb">
          <img
            id="thumb-{{ mediaUrl.cloudUri }}"
            class="thumb-image"
            [class.landscape]="mediaUrl.imageOrientation === ImageOrientation.LandscapeRight"
            [src]="mediaUrl['cloudUri']"
            (click)="onChange(mediaUrl['cloudUri'])"
            [class.current]="mediaUrl['cloudUri'] === currentUrl['cloudUri']" />
        </ng-container>

        <ng-template #fileTemplateThumb>
          <div
            id="thumb-{{ mediaUrl.cloudUri }}"
            [class.file-current]="mediaUrl['cloudUri'] === currentUrl['cloudUri']"
            (click)="onChange(mediaUrl['cloudUri'])">
            <div class="file-icon file-icon-{{ getExtension(mediaUrl.cloudUri)?.toLowerCase() }}">
              <div class="file-placeholder-text">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="file-label">{{ getExtension(mediaUrl.cloudUri) }}</div>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </ng-container>
  </div>
  <div class="images-list-arrow" (click)="goToNext()">
    <mat-icon>chevron_right</mat-icon>
  </div>
</div>
